import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, isRef as _isRef, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "incidentTab",
  class: ""
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "hstack gap-3" }
const _hoisted_5 = { class: "mb-3 maxwidth375" }
const _hoisted_6 = { class: "mb-3 w-100 maxwidth375" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "list-inline" }
const _hoisted_11 = { class: "list-inline-item" }
const _hoisted_12 = { class: "hstack gap-3" }
const _hoisted_13 = { class: "list-inline-item align-top" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-12 col-lg-4" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "col-md-12 col-lg-4" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "col-md-12 col-lg-4" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = {
  class: "mb-3",
  style: {"width":"750px"}
}
const _hoisted_23 = {
  key: 0,
  class: "hstack gap-3"
}
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "form-check" }
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = {
  key: 0,
  class: "list-group list-group-horizontal ms-3 mt-2"
}
const _hoisted_29 = { class: "list-group-item" }
const _hoisted_30 = { class: "form-check" }
const _hoisted_31 = { class: "list-group-item" }
const _hoisted_32 = { class: "form-check" }
const _hoisted_33 = { class: "list-group-item" }
const _hoisted_34 = { class: "form-check" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-12 col-lg-5" }
const _hoisted_37 = { class: "mb-3 container" }
const _hoisted_38 = { class: "row mb-3" }
const _hoisted_39 = { class: "col-6 text-end" }
const _hoisted_40 = { class: "row border" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "col-md-12 col-lg-5" }
const _hoisted_43 = { class: "mb-3 container" }
const _hoisted_44 = { class: "row mb-3" }
const _hoisted_45 = { class: "col-6 text-end" }
const _hoisted_46 = { class: "row border" }
const _hoisted_47 = ["onClick"]

import { defineComponent, ref, computed } from 'vue';
import { useContactsStore } from '../../stores/contactsStore';
import { storeToRefs } from 'pinia';
import SelectField from '../Misc/SelectField.vue';
import Datepicker from '@vuepic/vue-datepicker'; //https://vue3datepicker.com
import '@vuepic/vue-datepicker/dist/main.css';
import { InvestigationOutcome, ComplaintOutcome } from './schema';
import useValidation from '../Misc/validationUtils';

const dateFormat = "yyyy-MM-dd'T'HH:mm:ss";


export default /*@__PURE__*/_defineComponent({
  __name: 'Incident',
  setup(__props, { expose: __expose }) {

const contactsStore = useContactsStore();

var entryIntoProperty = ref((contactsStore.contactFullReport!.entry_details?.warrant || contactsStore.contactFullReport!.entry_details?.unannounced_entry || contactsStore.contactFullReport!.entry_details?.person_present) as boolean);
var getEntryIntoProperty = computed(() => {
    if (entryIntoProperty.value === undefined) {
        entryIntoProperty.value = contactsStore.contactFullReport!.entry_details?.warrant || contactsStore.contactFullReport!.entry_details?.unannounced_entry || contactsStore.contactFullReport!.entry_details?.person_present;
    }
    if (entryIntoProperty.value != undefined) {
        return entryIntoProperty.value;
    }
    return false;
});
let form = document.getElementById("mainForm") as HTMLFormElement;

if (form && form != null && form.classList.contains('was-validated')) {
    form.classList.remove('was-validated');
}

var { contactFullReport } = storeToRefs(useContactsStore());

const { validatableComponentArray, triggerValidation, addValidatableComponent, resetValidatableComponentArray } = useValidation();
__expose({triggerValidation});
function handleInvestigationOutcomeClick() {
    if (!contactsStore.contactFullReport!["investigation_outcome"]) {
        contactsStore.contactFullReport!.investigation_outcome = [] as InvestigationOutcome[];
    }

    contactsStore.contactFullReport!.investigation_outcome.push('' as InvestigationOutcome);
}

function handleComplaintOutcomeClick() {
    if (!contactsStore.contactFullReport!.complaint_outcome) {
        contactsStore.contactFullReport!.complaint_outcome = [] as ComplaintOutcome[];
    }

    contactsStore.contactFullReport!.complaint_outcome.push('' as ComplaintOutcome);
}

function isAlternatingRow(index: number): boolean {
    return index % 2 == 1;
}

function handleRemove(name: string, array: any, index: number) {
    resetValidatableComponentArray();
    array.splice(index, index >= 0 ? 1 : 0);
}

function handleEntryChange() {
    if (entryIntoProperty.value) {
        contactsStore.contactFullReport!.entry_details = { warrant: false, person_present: false, unannounced_entry: false }
    }
    else {
        contactsStore.contactFullReport!.entry_details = undefined;
    }
}

function handleTimeStampUpdate(event: any) {
    contactsStore.contactFullReport!.timestamp = event.format(dateFormat);
    return false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "eventIdentifier" }, [
              _createTextVNode("Event Identifier "),
              _createElementVNode("span", { class: "requiredfieldasterisk" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "eventIdentifier",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(contactsStore).contactFullReport!.event_identifier) = $event)),
              class: "form-control",
              required: true
            }, null, 512), [
              [_vModelText, _unref(contactsStore).contactFullReport!.event_identifier]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(SelectField, {
              modelValue: _unref(contactsStore).contactFullReport!.initiation,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(contactsStore).contactFullReport!.initiation) = $event)),
              "select-items": _unref(contactsStore).getInitiationType,
              "is-horizontal": false,
              "is-required": true,
              ref: (el) => { _unref(addValidatableComponent)(el) }
            }, {
              label: _withCtx(() => _cache[19] || (_cache[19] = [
                _createElementVNode("label", {
                  for: "initiation",
                  class: "form-label mb-0"
                }, [
                  _createTextVNode("Initiation "),
                  _createElementVNode("span", { class: "requiredfieldasterisk" }, "*")
                ], -1)
              ])),
              default: _withCtx(() => [
                _cache[20] || (_cache[20] = _createTextVNode("> "))
              ]),
              _: 1,
              __: [20]
            }, 8, ["modelValue", "select-items"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", _hoisted_11, [
              _cache[21] || (_cache[21] = _createElementVNode("label", {
                for: "dateTime",
                class: "form-label"
              }, [
                _createTextVNode("Date and Time "),
                _createElementVNode("span", { class: "requiredfieldasterisk" }, "*")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(Datepicker), {
                  modelValue: _unref(contactsStore).contactFullReport!.timestamp,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_unref(contactsStore).contactFullReport!.timestamp) = $event)),
                    _cache[3] || (_cache[3] = ($event: any) => (handleTimeStampUpdate($event)))
                  ],
                  format: dateFormat,
                  clearable: false,
                  required: true,
                  "input-class-name": 'form-control'
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("li", _hoisted_13, [
              _cache[22] || (_cache[22] = _createElementVNode("label", {
                for: "duration",
                class: "form-label"
              }, [
                _createTextVNode("Duration "),
                _createElementVNode("span", { class: "requiredfieldasterisk" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                id: "duration",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(contactsStore).contactFullReport!.duration) = $event)),
                required: true,
                "aria-required": "true"
              }, null, 512), [
                [_vModelText, _unref(contactsStore).contactFullReport!.duration]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(SelectField, {
            modelValue: _unref(contactsStore).contactFullReport!.location_type,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(contactsStore).contactFullReport!.location_type) = $event)),
            "select-items": _unref(contactsStore).getLocationType,
            "is-horizontal": false,
            "is-required": true,
            ref: (el) => { _unref(addValidatableComponent)(el) }
          }, {
            label: _withCtx(() => _cache[23] || (_cache[23] = [
              _createElementVNode("label", {
                for: "locationType",
                class: "form-label"
              }, [
                _createTextVNode("Location Type "),
                _createElementVNode("span", { class: "requiredfieldasterisk" }, "*")
              ], -1)
            ])),
            _: 1
          }, 8, ["modelValue", "select-items"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[24] || (_cache[24] = _createElementVNode("label", {
            for: "address",
            class: "form-label"
          }, [
            _createTextVNode("Address "),
            _createElementVNode("span", { class: "requiredfieldasterisk" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "address",
            class: "form-control",
            required: true,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(contactsStore).contactFullReport!.address_text) = $event))
          }, null, 512), [
            [_vModelText, _unref(contactsStore).contactFullReport!.address_text]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[25] || (_cache[25] = _createElementVNode("label", {
            for: "city",
            class: "form-label"
          }, [
            _createTextVNode("City "),
            _createElementVNode("span", { class: "requiredfieldasterisk" }, "*")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "city",
            class: "form-control",
            required: true,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(contactsStore).contactFullReport!.city) = $event))
          }, null, 512), [
            [_vModelText, _unref(contactsStore).contactFullReport!.city]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label" }, "Latitude / Longitude", -1)),
          (_unref(contactsStore).contactFullReport!.coordinates)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "latitude",
                  placeholder: "Latitude",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(contactsStore).contactFullReport!.coordinates.latitude) = $event))
                }, null, 512), [
                  [_vModelText, _unref(contactsStore).contactFullReport!.coordinates.latitude]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "longitude",
                  placeholder: "Longitude",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(contactsStore).contactFullReport!.coordinates.longitude) = $event))
                }, null, 512), [
                  [_vModelText, _unref(contactsStore).contactFullReport!.coordinates.longitude]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "form-check-input",
          id: "entry",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(contactsStore).contactFullReport!.was_use_of_force) = $event))
        }, null, 512), [
          [_vModelCheckbox, _unref(contactsStore).contactFullReport!.was_use_of_force]
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("label", {
          for: "wasUOF",
          class: ""
        }, " Was Force Used? ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "form-check-input",
          id: "entry",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(entryIntoProperty) ? (entryIntoProperty).value = $event : entryIntoProperty = $event)),
          onChange: _cache[12] || (_cache[12] = ($event: any) => (handleEntryChange()))
        }, null, 544), [
          [_vModelCheckbox, _unref(entryIntoProperty)]
        ]),
        _cache[28] || (_cache[28] = _createElementVNode("label", {
          for: "wasUOF",
          class: ""
        }, " Entry Into a Property? ", -1))
      ]),
      (_unref(getEntryIntoProperty) && _unref(contactsStore).contactFullReport!.entry_details)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
            _createElementVNode("li", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(contactsStore).contactFullReport!.entry_details.warrant) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _unref(contactsStore).contactFullReport!.entry_details.warrant]
                ]),
                _cache[29] || (_cache[29] = _createElementVNode("label", {
                  class: "",
                  for: "flexCheckDefault"
                }, " Officer had Warrant? ", -1))
              ])
            ]),
            _createElementVNode("li", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(contactsStore).contactFullReport!.entry_details.unannounced_entry) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _unref(contactsStore).contactFullReport!.entry_details.unannounced_entry]
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("label", {
                  class: "",
                  for: "flexCheckDefault"
                }, " Entry Unannounced? ", -1))
              ])
            ]),
            _createElementVNode("li", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "flexCheckDefault",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(contactsStore).contactFullReport!.entry_details.person_present) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _unref(contactsStore).contactFullReport!.entry_details.person_present]
                ]),
                _cache[31] || (_cache[31] = _createElementVNode("label", {
                  class: "",
                  for: "flexCheckDefault"
                }, " Person Present? ", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-6 my-auto" }, [
              _createElementVNode("h4", { class: "mb-0" }, "Complaints")
            ], -1)),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (handleComplaintOutcomeClick()), ["prevent"]))
              }, "Add")
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactFullReport)!.complaint_outcome, (complaint, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'bg-light': isAlternatingRow(index) }, "col-10 p-2"])
              }, [
                _createVNode(SelectField, {
                  "select-items": _unref(contactsStore).getComplaintOutcome,
                  modelValue: _unref(contactFullReport)!.complaint_outcome![index],
                  "onUpdate:modelValue": ($event: any) => ((_unref(contactFullReport)!.complaint_outcome![index]) = $event),
                  "is-horizontal": false,
                  "is-required": true,
                  ref_for: true,
                  ref: (el) => { _unref(addValidatableComponent)(el) }
                }, null, 8, ["select-items", "modelValue", "onUpdate:modelValue"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{ 'bg-light': isAlternatingRow(index) }, "col-2 p-2 mt-1 text-end"])
              }, [
                _createElementVNode("button", {
                  class: "btn-close me-3",
                  "aria-label": "Remove",
                  onClick: _withModifiers(($event: any) => (handleRemove(`complaint_outcome`, _unref(contactFullReport)!.complaint_outcome, index)), ["prevent"])
                }, null, 8, _hoisted_41)
              ], 2)
            ]))
          }), 256))
        ])
      ]),
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "d-md-none d-lg-flex col-lg-1 border-end" }, null, -1)),
      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "d-md-none d-lg-flex col-lg-1 border-start" }, null, -1)),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-6 my-auto" }, [
              _createElementVNode("h4", { class: "mb-0" }, "Investigations")
            ], -1)),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (handleInvestigationOutcomeClick()), ["prevent"]))
              }, "Add")
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactFullReport)!.investigation_outcome, (investigation, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'bg-light': isAlternatingRow(index) }, "col-10 p-2"])
              }, [
                _createVNode(SelectField, {
                  modelValue: _unref(contactFullReport)!.investigation_outcome![index],
                  "onUpdate:modelValue": ($event: any) => ((_unref(contactFullReport)!.investigation_outcome![index]) = $event),
                  "select-items": _unref(contactsStore).getInvestigationOutcome,
                  "is-horizontal": false,
                  "is-required": true,
                  ref_for: true,
                  ref: (el) => { _unref(addValidatableComponent)(el) }
                }, null, 8, ["modelValue", "onUpdate:modelValue", "select-items"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{ 'bg-light': isAlternatingRow(index) }, "col-2 p-2 mt-1 text-end"])
              }, [
                _createElementVNode("button", {
                  class: "btn-close me-3",
                  "aria-label": "Remove",
                  onClick: _withModifiers(($event: any) => (handleRemove(`investigation_outcome`, _unref(contactFullReport)!.investigation_outcome, index)), ["prevent"])
                }, null, 8, _hoisted_47)
              ], 2)
            ]))
          }), 256))
        ])
      ])
    ])
  ]))
}
}

})